import { BACKEND_URL } from 'configs'

export const getApiUrlTemplateFunc = (templatePath: string) => {
  return (path = '', params = {}) => {
    const paramKeys = Object.keys(params)
    const searchParamsPresent = paramKeys.length != 0
    const pathPresent = path != ''
    if (pathPresent && searchParamsPresent) {
      const searchParams = new URLSearchParams(params)
      return `${BACKEND_URL}/${templatePath}/${path}?${searchParams}`
    } else if (searchParamsPresent) {
      const searchParams = new URLSearchParams(params)
      return `${BACKEND_URL}/${templatePath}?${searchParams}`
    } else if (pathPresent) {
      return `${BACKEND_URL}/${templatePath}/${path}`
    } else {
      return `${BACKEND_URL}/${templatePath}`
    }
  }
}
